"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _Preferences = _interopRequireDefault(require("../Preferences"));
var _contexts = require("../../contexts");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-bind */

// Components

// Contents

// Styles

function StylesPopover() {
  var {
    showingStylePopover,
    toggleStylePopover,
    isDesktopView
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var classes = (0, _styles.default)();
  var HASH = 'styles';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        toggleStylePopover(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, toggleStylePopover]);
  (0, _react.useEffect)(() => {
    if (showingStylePopover) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [showingStylePopover]);
  var anchorOrigin = isDesktopView ? {
    vertical: 'top',
    horizontal: 'left'
  } : {
    vertical: 'top',
    horizontal: 'center'
  };
  var transformOrigin = isDesktopView ? {
    vertical: 'top',
    horizontal: 'left'
  } : {
    vertical: 'top',
    horizontal: 'center'
  };
  var spaceStyle = isDesktopView ? {
    top: 76,
    left: 105
  } : {
    top: 40,
    right: 16
  };
  var handleClosePopover = () => {
    toggleStylePopover(false);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: showingStylePopover,
    onClose: handleClosePopover,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    classes: {
      paper: classes.rootPopover
    },
    style: spaceStyle
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title,
    variant: "h6",
    color: "textSecondary"
  }, "Estilo", /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "fechar",
    onClick: handleClosePopover,
    className: classes.closePopover
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseSharp, null))), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_Preferences.default, null));
}
var _default = exports.default = StylesPopover;